// View 视图模式, 滚动查看消息下，可用于控制输入组件状态，来隐藏键盘
export enum ViewMode {
  Default = 1, // 默认视图模式
  ScrollView, // 滚动查看消息模式
}
